export default {
    'proofread': {
        name: 'proofread',
        label: 'Proofread',
        icon: 'fa fa-spell-check',
        color: 'bg-icon-blue',
        query: {section: 'proofread'},
        innerCategories: [
            'proofread.text_quality.spelling',
            'proofread.text_quality.grammar',
            'proofread.text_quality.readability',
            'proofread.text_quality.tone',
            'proofread.text_quality.capitalization']
    },
    'integrity': {
        name: 'integrity',
        label: 'Integrity',
        icon: 'fa fa-pen-fancy',
        color: 'bg-icon-purple',
        query: {section: 'proofread'},
        innerCategories: [
            'proofread.logic.contradictory_facts',
            'proofread.logic.numerical_inconsistency',
            'proofread.logic.heading_content_mismatch',
            'proofread.content_errors.missing_referenced_element',
            'proofread.content_errors.visible_error_message',
            'proofread.content_errors.spam_content',
            'proofread.content_errors.placeholder_text',
            'proofread.content_errors.unreplaced_variable',
        ]
    },
    'technical': {
        name: 'technical',
        label: 'Technical',
        icon: 'fa fa-code',
        color: 'bg-icon-gray',
        query: {section: 'audit'},
        innerCategories: [
            'technical.broken_link',
            'technical.broken_image',
            'technical.console_error',
            'technical.broken_resource',
            'technical.internal_redirect',
            'technical.missing_title',
            'technical.missing_description',
            'technical.missing_favicon',
            'technical.missing_alt',
        ]
    },
    'layout': {
        name: 'layout',
        label: 'Layout',
        icon: 'fa fa-tablet-screen-button',
        color: 'bg-icon-green',
        query: {section: 'audit'},
        innerCategories: [
            'layout.lsep',
            'layout.etx',
            'layout.unsupported_unicode',
            'layout.aspect_ratio',
            'layout.overflowing_container',
            'layout.outside_window',
            'layout.narrow',
            'layout.button_overlap',
            'layout.text_overlap',
            'layout.horizontal_scrolling',
        ]
    },
    'ai_readiness': {
        name: 'ai_readiness',
        label: 'AI Readiness',
        icon: 'fa fa-robot',
        color: 'bg-icon-orange',
        query: {section: 'ai_readiness'},
        innerCategories: [
            'ai_readiness.crawlability',
            'ai_readiness.visual_state_indicators',
            'ai_readiness.semantic_hierarchy',
            'ai_readiness.ghost_content',
            'ai_readiness.text_in_image',
            'ai_readiness.dynamic_content',
        ]
    },
    'qa': {
        name: 'qa',
        label: 'Watched Prompts',
        icon: 'fa fa-solid fa-wand-magic-sparkles',
        color: 'bg-icon-purple',
        query: {section: 'qa'},
        innerCategories: []
    },

}
